'use client';

import { UserFeedback as BaseUserFeedback } from '@leroy-merlin-br/backpack-user-feedback';

import { useUserResources } from '@/presenters/hooks/user';

export default function UserFeedback() {
  const { data: email } = useUserResources((data) => data.email);

  if (!email) {
    return null;
  }

  return (
    <BaseUserFeedback
      user={{
        email,
        isOnAssistedSale: false /* we don't have assisted sale context yet */,
      }}
    />
  );
}
